module.exports = "/packs/images/svg/facilities/ice_rink~f54582efc0826727407f24b9b2394657.svg";